import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 border-t border-brand-gold/30 bg-brand-cream text-center text-brand-graphite/70 text-sm" data-id="element-84" data-mp="32wd2cf6gdjt0">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-85" data-mp="3gh3rcermy6f5">
        <p className="text-xs leading-relaxed max-w-2xl mx-auto" data-id="element-86" data-mp="32ovvqqc38li1">
          © 2026 FUNCTIONAL PRO™ — All Rights Reserved. This product is
          intended for educational and professional development purposes only.
          It does not replace certified professional training or qualified
          medical advice. Always prioritise client safety and consult
          appropriate professionals where required.
        </p>
        <div className="flex justify-center gap-4 text-xs" data-id="element-87" data-mp="3le2katzkc7br">
          <a href="#" className="hover:text-brand-petrol transition-colors" data-id="element-88" data-mp="3qcnjcq32wkym">
            Terms & Conditions
          </a>
          <span data-id="element-89" data-mp="29ydrvn3jig3k">·</span>
          <a href="#" className="hover:text-brand-petrol transition-colors" data-id="element-90" data-mp="2a19v9qy5pwze">
            Privacy Policy
          </a>
          <span data-id="element-91" data-mp="3l9k5rctv1nda">·</span>
          <a href="#" className="hover:text-brand-petrol transition-colors" data-id="element-92" data-mp="3l90pe0juz71d">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}